export function isWhite(background) {
    background = hexToRgb(background);

    return getBrightness(background) > 240;
}

export function hasContrast(foreground, background) {
    if (!foreground || !background) return true;

    // http://www.had2know.com/technology/color-contrast-calculator-web-design.html
    foreground = hexToRgb(foreground);
    background = hexToRgb(background);

    if (!foreground || !background) return true;

    //https://github.com/bgrins/TinyColor isDark
    return getBrightness(background) < 138;
}

export function getBrightness(rgb) {
    //http://www.w3.org/TR/AERT#color-contrast
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
}

export function hexToRgb(hex) {
    // http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

// loader positions:
// 0 - top left
// 1 - top right
// 2 - bottom right
// 3 - bottom left

/**
 * @param {string} position - position as string ("tr", "bl", etc.)
 *
 * @returns {integer}
 */
export function mapPosition(position){
  return position === 'tl' ? 0 :
    position === 'tr' ? 1 :
      position === 'bl' ? 3 : 2;
}

export function getHorizontalParameters(position) {
    return isOnRight(position) ?
        {main: 'right', second: 'left', flex_start: 'flex-start', flex_end: 'flex-end', multiply: multiply(-1)} : //default widget position
        {main: 'left', second: 'right', _flex_start: 'flex-end', flex_end: 'flex-start', multiply: multiply(1)};
}

export function getVerticalParameters(position) {
    return isOnBottom(position) ?
        {main: 'bottom', second: 'top', multiply: multiply(1), rotate: '0deg'} : //default widget position
        {main: 'top', second: 'bottom', multiply: multiply(-1), rotate: '180deg'};
}

export function getTemplate(styleTemplate) {
    return styleTemplate === 'light' ? {frameWidth: 340, frameHeight: 490, frameHeightMobile: 409} :
        {frameWidth: 390, frameHeight: 590, frameHeightMobile: 509};
}

export function isOnBottom(position) {
    return [0, 1].indexOf(position) === -1;
}

export function isOnRight(position) {
    return [0, 3].indexOf(position) === -1;
}

export function multiply(multiplier) {
    return function (val) {
        return function (match, sign, p1, unit) {
            let value = val || p1;
            value = multiplier * (sign + value);
            unit = unit === 'pr' ? '%' : unit;

            return value + unit;
        }
    }
}
